import { memo, useMemo } from 'react';
import { RenderOnlyOnClient } from 'core/common/ui/widgets';
import { useThemeContext } from 'core/theme/contexts';
import { StarStyled } from './styled';

export const Stars = memo(() => {
  const { isLightTheme } = useThemeContext();
  const stopColor = isLightTheme ? '#4D3ADD' : '#AE9EEB';

  const starsData = useMemo(
    () =>
      Array.from({ length: 60 }, () => ({
        left: `${Math.random() * 100}%`,
        top: `${65 + Math.random() * 35}%`,
        pulseDelay: Math.random() * 5,
        pulseDuration: 3 + Math.random() * 7,
        starScale: 0.5 + Math.random() * 0.8,
      })),
    [],
  );

  return (
    <RenderOnlyOnClient>
      {starsData.map(({ left, top, pulseDelay, pulseDuration, starScale }, i) => (
        <StarStyled
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          key={`star-${i}`}
          left={left}
          top={top}
          pulseDelay={pulseDelay}
          pulseDuration={pulseDuration}
          starScale={starScale}
        >
          <g opacity="0.8">
            <ellipse cx="6.00158" cy="6" rx="0.638298" ry="6" fill="url(#g1)" />
            <ellipse
              cx="6"
              cy="6.00001"
              rx="0.638298"
              ry="6"
              transform="rotate(-90 6 6.00001)"
              fill="url(#g2)"
            />
          </g>
          <defs>
            <radialGradient
              id="g1"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(6.00158 6) rotate(90) scale(6 0.638298)"
            >
              <stop stopColor={stopColor} />
              <stop offset="1" stopColor={stopColor} stopOpacity="0.1" />
            </radialGradient>
            <radialGradient
              id="g2"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(6 6.00001) rotate(90) scale(6 0.638298)"
            >
              <stop stopColor={stopColor} />
              <stop offset="1" stopColor={stopColor} stopOpacity="0.1" />
            </radialGradient>
          </defs>
        </StarStyled>
      ))}
    </RenderOnlyOnClient>
  );
});
